module.exports = __webpack_public_path__ + "img/icon-mail-blue.32a723bc.svg";